export const bundleID = ''
export const bundleID4X = ''
export const bundleID4SD = ''

export const androidDownloadUrl = ``
export const iOSDownloadUrl = ''

export const androidDownloadUrl4SD = ''
export const iOSDownloadUrl4SD = ''

export const androidDownloadUrl4X = `https://play.google.com/store/apps/details?id=com.huna.voice`
export const iOSDownloadUrl4X = ''
export const directDownloadUrl4X = ``
export const androidLiteDownloadUrl4X = `https://play.google.com/store/apps/details?id=com.huna.voice.lite`
